const esc = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const parseMoney = (value) => Number(String(value || "").replace(/\D/g, "")) || 0;
const fmt = (value) => new Intl.NumberFormat("vi-VN").format(parseMoney(value));

const splitDate = (text = "") => {
  const [day = "...", month = "...", year = "...."] = String(text).split("/");
  return { day, month, year };
};

export const getPrintTemplate = ({ data }) => {
  const { day, month, year } = splitDate(data.documentDate);

  const rows = (data.items || [])
    .map(
      (item) => `
      <tr>
        <td>${esc(item.departmentName)}</td>
        <td>${esc(item.workContent)}</td>
        <td class="r">${fmt(item.estimatedCost)}</td>
        <td class="r">${fmt(item.actualCost)}</td>
        <td>${esc(item.inspectionResult)}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <title>Biên Bản Bàn Giao TSCĐ Sửa Chữa, Bảo Dưỡng, Nâng Cấp</title>
      <style>
        @media print { @page { margin: 8mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 14px; color: #000; line-height: 1.3; }
        .header { display: flex; justify-content: space-between; align-items: flex-start; }
        .center { text-align: center; }
        .line { margin-top: 4px; }
        table { border-collapse: collapse; width: 100%; margin-top: 6px; }
        th, td { border: 1px solid #000; padding: 4px; vertical-align: middle; }
        th { text-align: center; font-weight: 700; }
        .r { text-align: right; }
        .signature-row { margin-top: 26px; display: flex; justify-content: space-between; }
        .signature-box { width: 48%; text-align: center; }
        .sign-space { height: 68px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div>
          <div><b>Đơn vị:</b> ${esc(data.unit)}</div>
          <div><b>Bộ phận:</b> ${esc(data.department)}</div>
        </div>
        <div class="center">
          <div><b>Mẫu số: 03 - TSCĐ</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="center" style="margin-top: 14px; font-weight:700;">BIÊN BẢN BÀN GIAO TSCĐ</div>
      <div class="center" style="font-weight:700;">SỬA CHỮA, BẢO DƯỠNG HOẶC NÂNG CẤP, CẢI TẠO HOÀN THÀNH</div>
      <div class="center">Ngày ${esc(day)} tháng ${esc(month)} năm ${esc(year)}</div>

      <div style="display:flex; justify-content:flex-end; gap:20px; margin-top:8px;">
        <div>Số: ${esc(data.documentNumber)}</div>
        <div>Nợ: ${esc(data.debitAccount)}</div>
        <div>Có: ${esc(data.creditAccount)}</div>
      </div>

      <div class="line">Căn cứ Quyết định số: ${esc(data.decisionNumber)} ngày ${esc(data.decisionDate)} của ${esc(data.decisionBy)}</div>
      <div class="line">Chúng tôi gồm:</div>
      <div class="line">- Ông/Bà ${esc(data.repairRepresentativeName)} Chức vụ ${esc(data.repairRepresentativeTitle)} Đại diện ${esc(data.repairRepresentativeUnit)} đơn vị sửa chữa, bảo dưỡng hoặc nâng cấp, cải tạo</div>
      <div class="line">- Ông/Bà ${esc(data.assetRepresentativeName)} Chức vụ ${esc(data.assetRepresentativeTitle)} Đại diện ${esc(data.assetRepresentativeUnit)} đơn vị có TSCĐ.</div>
      <div class="line">Đã kiểm nhận việc sửa chữa, bảo dưỡng hoặc nâng cấp, cải tạo TSCĐ như sau:</div>
      <div class="line">- Tên, ký mã hiệu, quy cách (cấp hạng) TSCĐ ${esc(data.assetNameSpecification)}</div>
      <div class="line">- Số hiệu TSCĐ ${esc(data.assetCode)} Số thẻ TSCĐ ${esc(data.assetCardNumber)}</div>
      <div class="line">- Bộ phận quản lý, sử dụng: ${esc(data.managementDepartment)}</div>
      <div class="line">- Thời gian sửa chữa, bảo dưỡng hoặc nâng cấp, cải tạo từ ngày ${esc(data.workStartDate)} đến ngày ${esc(data.workEndDate)}</div>
      <div class="line">Các bộ phận sửa chữa, bảo dưỡng hoặc nâng cấp, cải tạo gồm có:</div>

      <table>
        <thead>
          <tr>
            <th>Tên bộ phận cần sửa chữa, bảo dưỡng, hoặc nâng cấp, cải tạo</th>
            <th>Nội dung (mức độ) công việc sửa chữa, bảo dưỡng hoặc nâng cấp, cải tạo</th>
            <th>Giá dự toán</th>
            <th>Chi phí thực tế</th>
            <th>Kết quả kiểm tra sau sửa chữa, bảo dưỡng hoặc nâng cấp, cải tạo</th>
          </tr>
          <tr>
            <th>A</th>
            <th>B</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
          </tr>
        </thead>
        <tbody>
          ${rows}
          <tr>
            <td colspan="2" style="text-align:center;"><b>Cộng</b></td>
            <td class="r"><b>${fmt(data.totalEstimatedCost)}</b></td>
            <td class="r"><b>${fmt(data.totalActualCost)}</b></td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <div class="line">Kết luận: ${esc(data.conclusion)}</div>

      <div class="signature-row">
        <div class="signature-box">
          <div><b>Đại diện đơn vị nhận</b></div>
          <div><i>(Ký, họ tên)</i></div>
          <div class="sign-space"></div>
          <div><b>${esc(data.receiverSignName)}</b></div>
        </div>
        <div class="signature-box">
          <div><b>Đại diện đơn vị giao</b></div>
          <div><i>(Ký, họ tên)</i></div>
          <div class="sign-space"></div>
          <div><b>${esc(data.giverSignName)}</b></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
